
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-strategy",
      function () {
        return require("private-next-pages/create-strategy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-strategy"])
      });
    }
  